export var RXDB_PREMIUM_VERSION="15.36.0";